export const aciCheckStepper = {
    iconName: 'check-stepper',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 24' },
        path: {
            attr: {
                'fill-rule': 'evenodd',
                'clip-rule': 'evenodd',
                d: 'M20.42 3.012a.429.429 0 00-.181.08c-.046.037-2.188 3.08-5.82 8.27-4.16 5.944-5.782 8.248-5.873 8.341-.139.141-.35.26-.557.312a1.238 1.238 0 01-.8-.095c-.252-.124-.236-.105-1.854-2.26-1.693-2.255-1.591-2.135-1.83-2.15a.428.428 0 00-.36.125.6.6 0 00-.11.149.536.536 0 00.005.395c.057.112 2.997 4.027 3.134 4.174a2.2 2.2 0 001.175.623c.223.042.676.027.885-.029a2.197 2.197 0 001.125-.702c.156-.191 11.562-16.49 11.605-16.582a.508.508 0 00-.013-.407c-.1-.198-.3-.29-.532-.244z',
                fill: 'currentColor',
            },
        },
    },
};
